import { useForm } from '@fuse/hooks';
import { Icon, IconButton, Input, ListItem } from '@material-ui/core';
import React from 'react';
import AnotacaoListItemModel from '../../Model/AnotacaoListItemModel';

function AnotacaoFormAddListItem(props) {
    const { form, handleChange, resetForm } = useForm(
        {
            text: ""
        }
    );

    function isFormInValid() {
        return form.text === '';
    }

    function handleSubmit(ev) {
        ev.preventDefault();
        if (isFormInValid()) {
            return;
        }
        props.onListItemAdd(new AnotacaoListItemModel(form));
        resetForm();
    }

    return (
        <form onSubmit={handleSubmit}>
            <ListItem className="p-0" dense>
                <IconButton
                    className="w-32 h-32 -ml-4 mr-4 p-0"
                    aria-label="Add"
                    type="submit"
                    disabled={isFormInValid()}
                >
                    <Icon fontSize="small">add</Icon>
                </IconButton>
                <Input
                    className="flex flex-1"
                    name="text"
                    value={form.text}
                    onChange={handleChange}
                    placeholder="Adicionar item"
                    disableUnderline
                    autoFocus
                />
            </ListItem>
        </form>
    );
}

export default AnotacaoFormAddListItem;
